<template>
  <div class="home">
    <template v-if="pageData === null">
      <div class="spinnerSection">
        <div class="logo-loading">
          <img :src="getImage('logo.png')" /><br />
        </div>
        <div class="message-loading">
          <strong>Loading</strong>
        </div>
        <b-spinner class="spinner-icon" label="Spinning"></b-spinner>
      </div>
    </template>
    <template v-else v-cloak>
      <div>
        <!-- Start Jumbotron -->
        <b-jumbotron class="hero">
          <p class="text-center">
            <img class="hero-image" :src="getImage('logo.png')" />
          </p>
          <h3
            v-if="pageData.slogan"
            v-html="pageData.slogan"
            class="display-4 text-center mb-5 slogan"
          ></h3>
          <h3 class="display-3 text-center" v-else>
            Welcome to the RM of Chaplin!
          </h3>
          <div class="container">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-4 mb-3">
                <div class="card">
                  <figure class="cards">
                    <img :src="events_image" class="card-img-top" alt="..." />
                  </figure>
                  <div class="card-body">
                    <h5 class="card-title">Events</h5>
                    <p
                      class="card-text"
                      v-if="pageData.events_desc"
                      v-html="pageData.events_desc"
                    ></p>
                    <p class="card-text" v-else>
                      Check out our current events scheduled for this year!
                    </p>
                    <p class="text-right mb-0">
                      <router-link to="/news" href="#" class="btn btn-primary"
                        >View All Events</router-link
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-4 mb-3">
                <div class="card">
                  <figure class="cards">
                    <img :src="news_image" class="card-img-top" alt="..." />
                  </figure>
                  <div class="card-body">
                    <h5 class="card-title">News</h5>
                    <p
                      class="card-text"
                      v-if="pageData.news_desc"
                      v-html="pageData.news_desc"
                    ></p>
                    <p class="card-text" v-else>
                      Catch up on the latest news in our community!
                    </p>
                    <p class="text-right mb-0">
                      <router-link to="/news" class="btn btn-primary"
                        >View Latest News</router-link
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-4 mb-3">
                <div class="card">
                  <figure class="cards">
                    <img :src="business_image" class="card-img-top" alt="..." />
                  </figure>
                  <div class="card-body">
                    <h5 class="card-title">Business</h5>
                    <p
                      class="card-text"
                      v-if="pageData.business_desc"
                      v-html="pageData.business_desc"
                    ></p>
                    <p class="card-text" v-else>
                      Some quick example text to build on the card title and
                      make up the bulk of the card's content.
                    </p>
                    <p class="text-right mb-0">
                      <router-link to="/businesses" class="btn btn-primary"
                        >View Business Information</router-link
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-jumbotron>
      </div>
      <!-- End Jumbotron -->
      <div>
        <!-- Welcome Section -->
        <div class="container welcome-section mx-auto">
          <div class="row">
            <div class="col-sm-12 col-md-7 col-lg-7 welcome-desc">
              <div class="px-3"
                v-if="pageData.welcome_message"
                v-html="pageData.welcome_message"
              ></div>
              <div class="px-3" v-else>
                <h2>Welcome!</h2>
                <p>
                  The RM of Chaplin is community consisting of Farmers, Minors
                  and people from all walks of life. Located on the Trans-Canada
                  Highway and home to an amazing bird-watching sanctuary and
                  bountiful salt maining operation.
                </p>
              </div>
            </div>
            <div class="col-sm-12 col-md-5 col-lg-5">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title text-center my-5">
                    Newsletter Sign Up
                  </h5>
                  <p
                    class="card-text"
                    v-if="pageData.newsletter_desc"
                    v-html="pageData.newsletter_desc"
                  ></p>
                  <p class="card-text" v-else>
                    Curious about what's happening in the rural municipality of
                    Chaplin? Sign up today to get updates on events and news in
                    our community!
                  </p>
                  <p class="newsletterSignup px-0">
                    <input
                      type="text"
                      v-model="nameSignUp"
                      class="form-control"
                      placeholder="Enter your name"
                      required
                    />
                  </p>
                  <p class="newsletterSignup px-0">
                    <input
                      type="email"
                      v-model="emailSignUp"
                      class="form-control"
                      placeholder="Enter your email"
                      required
                    />
                  </p>
                  <p class="text-right">
                    <button @click="signUp" class="btn btn-primary">
                      SIGN UP
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Welcome Section -->
      <div class="container-fluid triptich-container">
        <div class="row no-gutters">
          <div class="col-sm-12 col-md-4 col-lg-4">
            <figure class="triptich">
              <img :src="image1" alt="" />
            </figure>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4">
            <figure class="triptich">
              <img :src="image2" alt="" />
            </figure>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4">
            <figure class="triptich">
              <img :src="image3" alt="" />
            </figure>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";


export default {
  name: "Home",
  data() {
    return {
      emailSignUp: "",
      nameSignUp: "",
      pageData: null
    };
  },
  created() {
    this.getPage();
  },
  methods: {
    getImage(value) {
      return process.env.VUE_APP_IMAGES + value;
    },
    getPage() {
      axios
        .get(process.env.VUE_APP_SERVER + "homepage")
        .then(res => {
          if (res.data) {
            this.pageData = res.data.result[0];
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    signUp() {
      if (this.nameSignUp.length && this.emailSignUp.length) {
        console.log("SUBMIT");
        axios
          .post(process.env.VUE_APP_SERVER + "signup", {
            email: this.emailSignUp,
            name: this.nameSignUp
          })
          .then(() => {
            this.$noty.success("You have been added to our Newsletter!");
          })
          .catch(() =>
            this.$noty.error("There was an error adding your email.")
          );
      }
    }
  },
  computed: {
    business_image() {
      return this.pageData.business_image
        ? process.env.VUE_APP_IMAGES + this.pageData.business_image
        : "https://picsum.photos/600/300/?image=25";
    },
    events_image() {
      return this.pageData.events_image
        ? process.env.VUE_APP_IMAGES + this.pageData.events_image
        : "https://picsum.photos/600/300/?image=25";
    },
    news_image() {
      return this.pageData.news_image
        ? process.env.VUE_APP_IMAGES + this.pageData.news_image
        : "https://picsum.photos/600/300/?image=25";
    },
    image1() {
      return this.pageData.image_1
        ? process.env.VUE_APP_IMAGES + this.pageData.image_1
        : "https://picsum.photos/600/300/?image=25";
    },
    image2() {
      return this.pageData.image_2
        ? process.env.VUE_APP_IMAGES + this.pageData.image_2
        : "https://picsum.photos/600/300/?image=25";
    },
    image3() {
      return this.pageData.image_3
        ? process.env.VUE_APP_IMAGES + this.pageData.image_3
        : "https://picsum.photos/600/300/?image=25";
    }
  }
};
</script>

<style lang="scss">
.hero {
  background: url("../assets/images/grain_elevator.jpg");
  background-size: cover;
  background-position: 50%;
  border-radius: 0 !important;

  .hero-image {
    width: 100%;
    max-width: 400px;
  }

  figure.cards {
    margin: 0 0 1rem;
    max-height: 165px;
    overflow: hidden;

    margin-bottom: 1rem;

    img {
      position: relative;
      width: 110%;
    }
  }
  .slogan {
    color: white;
    text-shadow: 0 0 3px #000;
  }
}

.welcome-section {
  margin: 0;
  margin-bottom: 1.5rem;
  word-break: break-word;

  .welcome-desc {
    div {
      :first-child {
        margin-bottom: 2rem;
      }
    }
  }

  @media all and (max-width: 416px) and (max-height: 825px) {
    padding: initial !important;

    .row {
      display: block;
      margin-right: 0;
      margin-left: 0;
    }
  }  
}

.triptich-container {
  margin-top: 2rem;
  max-width: 100%;
  padding: 0 !important;
  overflow: hidden;

  figure.triptich {
    margin: 0;
    height: 300px;
    max-height: 300px;
    min-width: 110%;
    overflow: hidden;
    display: block !important;
    position: relative;

    img {
      margin: auto;
      position: absolute;
      width: 110%;
      max-height: 500px;
      left: -50%;
      right: -50%;
      top: -50%;
      bottom: -50%;
    }
  }
}
.newsletterSignup {
  .email {
    display: inline-flex;
    max-width: 200px;
  }
}

.spinnerSection {
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: #fff;
  z-index: 9999;
  position: fixed;
  text-align: center;

  .logo-loading {
    margin-top: 10%;
  }

  .message-loading {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  @media all and (max-width: 321px) {
    .logo-loading {
      margin-top: 5%;
      img {
        width: 100% !important;
      }
    }
  }
}
</style>
